import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class OrganizationSettings extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    /**
     * Create model list from api return
     */
    static list(item) {
        return this.fromJSON(item);
    }

    static listUrl({ organizationId }) {
        return `/ticket/organizations/${organizationId}/settings/partners`;
    }
}
